import type { TradesDataItem } from "@gameApp/trades/types";

export function tradesMapList(raw: null | unknown[]): TradesDataItem[] {
  if (Array.isArray(raw)) {
    return raw.map((rawItem) => tradesMapItem(rawItem));
  }

  return [];
}

export function tradesMapItem(raw: null | unknown): TradesDataItem {
  if (raw && typeof raw === "object") {
    const nextItem = raw as TradesDataItem;

    return nextItem;
  }

  const nextItem = {} as TradesDataItem;

  return nextItem;
}
